import { render, staticRenderFns } from "./StaffList.vue?vue&type=template&id=6c00ddbc&scoped=true&"
import script from "./StaffList.vue?vue&type=script&lang=js&"
export * from "./StaffList.vue?vue&type=script&lang=js&"
import style0 from "./StaffList.vue?vue&type=style&index=0&id=6c00ddbc&lang=scss&scoped=true&"
import style1 from "./StaffList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c00ddbc",
  null
  
)

export default component.exports